import { render, staticRenderFns } from "./toTop.vue?vue&type=template&id=511c7d6d&"
import script from "./toTop.vue?vue&type=script&lang=js&"
export * from "./toTop.vue?vue&type=script&lang=js&"
import style0 from "./toTop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports